import React from 'react';
import { Alert } from 'antd';
import { OutcomeResponse } from '../types/outcomeTypes';

interface Props {
    result: OutcomeResponse | null;
}

const ResultBanner: React.FC<Props> = ({ result }) => {
    if (!result) return null;

    if (result.success) {
        return (
            <Alert
                type="success"
                showIcon
                message="All services updated successfully"
                description={`Response ID: ${result.responseId}`}
            />
        );
    }

    const issueText = result.issues.map(i => i.message).join(' · ');
    return (
        <Alert
            type="error"
            showIcon
            message="Update failed"
            description={issueText || `Response ID: ${result.responseId}`}
        />
    );
};

export default ResultBanner;
